import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

import Input from '@material-ui/core/Input'
import IconButton from '@material-ui/core/IconButton'

import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import CreateIcon from '@material-ui/icons/Create'

import styles from '../../styles'

export class EditInput extends React.Component {
    state = {
      value: this.props.value,
      editable: false,
    }
    handleChange = (e) => {
      const value = e.target.value;
      this.setState({ value });
    }
    check = () => {
      this.setState({ editable: false });
      if (this.props.onChange) {
        this.props.onChange(this.state.value);
      }
    }
    cancel = () => {
      this.setState({ editable: false });
    }
    edit = () => {
      this.setState({ editable: true });
    }
    render() {
      const { value, editable } = this.state
      const { classes } = this.props
      return (
        <div >
          {
            editable ?
              <div >
                <Input className={classes.textField}
                  value={value}
                  onChange={this.handleChange}
                  required={true}
                />
                <IconButton className={classes.editIcon}
                                  color="inherit"
                                  aria-label="Enter value"
                                  onClick={this.check}
                              ><CheckIcon />
                              </IconButton>
                
                              <IconButton className={classes.editIcon}
                                  color="inherit"
                                  aria-label="Cancel edit"
                                  onClick={this.cancel}
                              >
                                  <ClearIcon />
                              </IconButton>              
              </div>
              :
              <div >
                {value || ' '}
                              <IconButton className={classes.editIcon}
                                  color="inherit"
                                  aria-label="Cancel edit"
                                  onClick={this.edit}
                              >
                                  <CreateIcon />
                              </IconButton> 
              </div>
          }
        </div>
      );
    }
  }

  EditInput = withStyles(styles, {withTheme: true})(EditInput)


// WEBPACK FOOTER //
// ./src/components/table/EditInput.jsx